import { Column } from 'components/shared/TableListing';
import { EligibleFinanceProgramTableRow, EligibleFinanceProgramsContext } from '../types';
import { Chip, Radio, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import { green, grey } from '@mui/material/colors';

export const columns: Column<EligibleFinanceProgramTableRow, EligibleFinanceProgramsContext>[] = [
  {
    header: 'Select',
    renderKey: 'selectable',
    width: '5%',
    cellStyles: { justifyContent: 'center' },
    renderCell: ({ row, context }) => {
      if (!row.selectable) return null;

      return <Radio size="small" checked={context.selectedId === row.id} onChange={() => context.onSelect(row.id)} />;
    },
  },
  {
    header: 'Program',
    renderKey: 'name',
    width: '30%',
    renderCell: ({ row }) => (
      <Stack
        direction="row"
        gap="0.5rem"
        alignItems="center"
        justifyContent="space-between"
        sx={{ paddingLeft: row.isTier ? '1.5rem' : 0, width: '100%' }}
      >
        <Stack direction="row" gap="0.5rem" alignItems="center">
          {row.isTier && <SubdirectoryArrowRightIcon sx={{ color: grey[500] }} />}

          <Typography
            variant="body2"
            fontWeight={500}
            color={!row.isTier ? 'primary' : 'textSecondary'}
            sx={{ cursor: !row.isTier ? 'pointer' : 'default' }}
          >
            {row.name}
          </Typography>

          <Chip
            size="small"
            label={<Typography>{row.isTier ? 'Tier' : 'Program'}</Typography>}
            variant="outlined"
            sx={{ opacity: 0.5 }}
          />
        </Stack>

        <Stack direction="row" gap="0.5rem" alignItems="center">
          {row.isRecommended && (
            <Chip
              size="small"
              label={<Typography fontWeight={500}>Recommended</Typography>}
              icon={<ThumbUpIcon sx={{ fontSize: '0.875rem' }} />}
              sx={{ backgroundColor: green[50], color: green[600], '& .MuiChip-icon': { color: green[600] } }}
            />
          )}

          {row.isQualified && (
            <>
              <CheckIcon sx={{ color: green[400], fontSize: '0.875rem' }} />
              <Typography sx={{ color: green[400] }}>Qualified</Typography>
            </>
          )}
        </Stack>
      </Stack>
    ),
  },
  {
    header: 'Max Amount',
    renderKey: 'maxAmount',
    width: '15%',
    renderCell: ({ row }) => <Typography variant="body2">{row.maxAmount}</Typography>,
  },
  {
    header: 'Max Term',
    renderKey: 'maxTerm',
    width: '15%',
    renderCell: ({ row }) => <Typography variant="body2">{row.maxTerm}</Typography>,
  },
  {
    header: 'Terms',
    renderKey: 'terms',
    width: '15%',
    renderCell: ({ row }) => <Typography variant="body2">{row.terms}</Typography>,
  },
  {
    header: 'Rate',
    renderKey: 'rate',
    width: '10%',
    renderCell: ({ row }) => <Typography variant="body2">{row.rate}</Typography>,
  },
  {
    header: 'Down Payment',
    renderKey: 'downPayment',
    width: '10%',
    renderCell: ({ row }) => <Typography variant="body2">{row.downPayment}</Typography>,
  },
];
